export enum OptitimeReserveStatus {
    TAKEN_BY_FC = 'TAKEN_BY_FC',
    FULLY_RESERVE = 'FULLY_RESERVE',
    CONFIRMED = 'CONFIRMED',
    CANCELED = 'CANCELED',
}
